import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    Box,
    IconButton
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import BlueButton from '../BlueButton';

/**
 * Modal de Confirmação Reutilizável
 * @param {boolean} open - Se o modal está aberto
 * @param {function} onClose - Função para fechar o modal
 * @param {function} onConfirm - Função executada ao confirmar
 * @param {string} title - Título do modal
 * @param {string} message - Mensagem principal
 * @param {string} confirmText - Texto do botão de confirmação
 * @param {string} cancelText - Texto do botão de cancelar
 * @param {string} severity - Tipo de alerta: 'warning', 'error', 'info', 'success'
 * @param {React.ReactNode} children - Conteúdo adicional (opcional)
 */
const ModalConfirmacao = ({
    open,
    onClose,
    onConfirm,
    title = 'Confirmar Ação',
    message = 'Você tem certeza que deseja realizar esta ação?',
    confirmText = 'Confirmar',
    cancelText = 'Cancelar',
    severity = 'warning',
    children
}) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
        >
            <DialogTitle sx={{ bgcolor: severity === 'error' ? '#d32f2f' : '#ed6c02', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1 }}>
                <span>{title}</span>
                <IconButton aria-label="fechar" onClick={onClose} sx={{ color: 'white', padding: 0.5 }}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            <DialogContent dividers>
                <Typography variant="body1" sx={{ pt: 1 }}>
                    {message}
                </Typography>

                {children && (
                    <Box sx={{ mt: 2 }}>
                        {children}
                    </Box>
                )}
            </DialogContent>

            <DialogActions sx={{ p: 2 }}>
                <Button onClick={onClose} color="inherit" variant="outlined">
                    {cancelText}
                </Button>
                <BlueButton
                    textValue={confirmText}
                    clickFunction={() => {
                        onConfirm();
                        onClose();
                    }}
                />
            </DialogActions>
        </Dialog>
    );
};

export default ModalConfirmacao;
